import { createStyles } from '@material-ui/core';

const styles = () => createStyles({
  property: {
    opacity: '0.6',
  },
  value: {
    marginTop: '3px',
  },
});

export default styles;
